import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import Icon from '../../../atoms/Icon';
import SizeGuideFooterStyles from './SizeGuideFooter.pcss';
import { appInterceptor } from '../../../../games/stw/methods/appInterceptors';
import properties from '../../../../modules/ajio-util/properties';

const cx = classNames.bind(SizeGuideFooterStyles);

class SelfcareGA extends React.Component {
  constructor(props) {
    super(props);
    this.label = {
      szGuideTxt: this.props.szGuideTxt
    };
    this.state = {
      selectedValue: null,
    };
  }

  customerFeedback(value = '', tab = '') {
    const { isApp = false } = this.props;
    if (isApp) {
      appInterceptor('true', {
        type: 'CUSTOMER_FEEDBACK',
        clicked: 'customer feedback',
        tab,
        value
      });
    }
  }

  _thumbsDown() {
    const { productCode = '', productName = '', type = 'guide', luxe = false, isApp = false } =
      this.props || {};
    if (isApp) {
      this.customerFeedback(
        'negative',
        type === 'guide'
          ? 'size guide'
          : type === 'measure'
          ? 'how to measure'
          : 'international conversions'
      );
    }

    if (!isApp) {
      gtmEventPush({
        event: 'customer_feedback_interactions',
        event_category: 'size chart interactions',
        event_action:
          type === 'guide'
            ? 'Size Guide'
            : type === 'measure'
            ? 'How to measure'
            : 'International conversions',
        event_label: 'negative review',
        page_type: 'size guide screen',
        page_name: 'size guide screen',
        product_name: productName,
        product_id: productCode,
        store_type: luxe ? 'luxe' : 'ajio'
      });

      segmentEventPush({
        event: 'Size Chart Interaction',
        event_category: 'size chart interactions',       
        interaction_description: type === 'guide'
            ? 'Size Guide'
            : type === 'measure'
            ? 'How to measure'
            : 'International conversions',
        // page_type: pageType,
        screen_name: 'size guide screen',
        product_name: productName,
        product_id: productCode,
        //product_brand: brandName,
        // product_size: selectedSizeName,
        store_type: luxe ? 'luxe' : 'ajio'
      });
    }
    // ReactDOM.findDOMNode(this.refs.thumbsDown).classList.add(cx('thumbs-down'));
    // if (this.refs.thumbsUP) {
    //   ReactDOM.findDOMNode(this.refs.thumbsUP).classList.remove(cx('thumbs-up'));
    // }
    this.setState({ selectedValue: 'dislike' });
  }

  _thumbsUp() {
    const { productCode = '', productName = '', type = 'guide', luxe = false, isApp = false } =
      this.props || {};
    if (isApp) {
      this.customerFeedback(
        'positive',
        type === 'guide'
          ? 'size guide'
          : type === 'measure'
          ? 'how to measure'
          : 'international conversions'
      );
    }

    if (!isApp) {
      gtmEventPush({
        event: 'customer_feedback_interactions',
        event_category: 'size chart interactions',
        event_action:
          type === 'guide'
            ? 'Size Guide'
            : type === 'measure'
            ? 'How to measure'
            : 'International conversions',
        event_label: 'positive review',
        page_type: 'size guide screen',
        page_name: 'size guide screen',
        product_name: productName,
        product_id: productCode,
        store_type: luxe ? 'luxe' : 'ajio'
      });

       segmentEventPush({
        event: 'Size Chart Interaction',
        event_category: 'size chart interactions',       
        interaction_description:  type === 'guide'
            ? 'Size Guide'
            : type === 'measure'
            ? 'How to measure'
            : 'International conversions',
        // page_type: pageType,
        screen_name: 'size guide screen',
        product_name: productName,
        product_id: productCode,
        //product_brand: brandName,
        // product_size: selectedSizeName,
        store_type: luxe ? 'luxe' : 'ajio'
      });

    }
    // ReactDOM.findDOMNode(this.refs.thumbsUP).classList.add(cx('thumbs-up'));
    // if (this.refs.thumbsDown) {
    //   ReactDOM.findDOMNode(this.refs.thumbsDown).classList.remove(cx('thumbs-down'));
    // }
    this.setState({ selectedValue: 'like' });
  }

  render() {
    const { selectedValue } = this.state;
    return (
      <div className={cx('sizeGuideReview')}>
        <div className={cx('selfcare-gainfo')}>
          <span className={cx('washelpful-header')} id="selfcare-ga-label">{this.label.szGuideTxt}</span>
          <div className={cx('thumbs-container')} role="radiogroup" aria-labelledby="selfcare-ga-label">
            <div
              ref="thumbsUP"
              role="radio"
              aria-checked={selectedValue === 'like'}
              tabIndex={0}
              onClick={this._thumbsUp.bind(this)}
              onKeyDown={(e) => e.key === 'Enter' && this._thumbsUp()}
              aria-labelledby="selfcare-ga-label like-button"
            >
              {
                selectedValue === 'like' ?  <img ariaHidden={true} src={`${`${properties.getProperty('imageBaseUrl')}/static/img/thumbs-up-icon.svg`}`} style={{marginRight: '20px'}}/> : <Icon
                  icon="icon-Like"
                  iconClass={cx('likeIcon')}
                  ariaHidden={true}
                />
              }
              <span id="like-button" className={cx("sr-only")}>Like</span>
            </div>
            <div 
              ref="thumbsDown"
              role="radio"
              aria-checked={selectedValue === 'dislike'}
              tabIndex={0}
              onClick={this._thumbsDown.bind(this)}
              onKeyDown={(e) => e.key === 'Enter' && this._thumbsDown()}
              aria-labelledby="selfcare-ga-label dislike-button"
            >
              {selectedValue === 'dislike' ? <img ariaHidden={true} src={`${`${properties.getProperty('imageBaseUrl')}/static/img/thumbs-down-icon.svg`}`}/> : <Icon
                icon="icon-Dislike"
                iconClass={cx('dislikeIcon')}
                ariaHidden={true}
              />
              }
              <span id="dislike-button" className={cx("sr-only")}>Dislike</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelfcareGA;
